/**
 * Predefined array of colors that work well with black or gray text
 * These colors have been selected to ensure good contrast and visibility
 */
export const colorPool: string[] = [
  // Brighter colors with good contrast for dark text
  "#8EEDC7", // Mint (brighter)
  "#A7B5FF", // Periwinkle (brighter)
  "#FFB980", // Peach (brighter)
  "#FF9B9B", // Light Pink (brighter)
  "#D4FF8A", // Light Green (brighter)
  "#E5C1FF", // Lavender (brighter)
  "#A7D8FF", // Light Blue (brighter)
  "#FFE066", // Light Yellow (brighter)
  "#FFA07A", // Light Coral (brighter)
  "#99E6FF", // Sky Blue (brighter)
  "#D896FF", // Light Purple (brighter)
  "#C5FF95", // Light Lime (brighter)
  "#FFAB6B", // Light Orange (brighter)
  "#87FFFF", // Light Cyan (brighter)
  "#FFF459", // Light Gold (brighter)
  "#7ADBD3", // Light Teal (brighter)
  "#FF9E8A", // Light Salmon (brighter)
  "#B8A9FF", // Light Slate (brighter)
  "#FF9BBF", // Light Rose (brighter)
  "#A8E6FF", // Light Azure (brighter)
];

export type Currency = "Chips" | "Usd" | "BB";

/*
console.log(Object.entries(
  calcForBarChart.reduce(
    (acc, item) => {
      acc.rakedProfit.push(item.rakedProfit);
      acc.rakedProfitUsd.push(item.rakedProfitUsd);
      acc.allWinnersRakeByPeriod.push(item.allWinnersRakeByPeriod);
      acc.allWinnersCountByPeriod.push(item.allWinnersCountByPeriod);
      acc.allWinnersHandsByPeriod.push(item.allWinnersHandsByPeriod); //not for pie
      acc.allWinnersAvgCoinPriceByPeriod.push(item.allWinnersAvgCoinPriceByPeriod); //not for pie
      acc.allWinnersAvgBigBlindByPeriod.push(item.allWinnersAvgBigBlindByPeriod); //not for pie

      acc.allLosersHandsByPeriod.push(item.allLosersHandsByPeriod); //only for AU
      acc.allLosersRakeByPeriod.push(item.allLosersRakeByPeriod); //only for AU
      acc.allLoserProfitByPeriod.push(item.allLoserProfitByPeriod); //only for AU

      return acc;
    },
    {
      rakedProfit: [] as number[],
      rakedProfitUsd: [] as number[],
      allWinnersRakeByPeriod: [] as number[],
      allWinnersCountByPeriod: [] as number[],
      allWinnersHandsByPeriod: [] as number[], //not for pie
      allWinnersAvgCoinPriceByPeriod: [] as number[], //not for pie
      allWinnersAvgBigBlindByPeriod: [] as number[],  //not for pie

      allLosersRakeByPeriod: [] as number[], //only for AU
      allLosersHandsByPeriod: [] as number[], //only for AU
      allLoserProfitByPeriod: [] as number[], //only for AU
      //net loser count
    }
  )
  ?? {}))*/

//First svetofor chart. Info for all periods
// export const calculateDataForPieChart = (data: PeriodStatisticsDto[]) => {
//   //if (data === undefined) return {};
//
//   const totals = data?.reduce((acc, item) => {
//
//     for (const key in item) {
//       // @ts-ignore
//       if (typeof item[key] === "number") {
//         // @ts-ignore
//         acc[key] = (acc[key] || 0) + item[key];
//       }
//     }
//     return acc;
//   }, {} as PeriodStatisticsDto);
//
//   if (totals === undefined) return {};
//   const winnerProfi = totals.middle_winner_gross_profit + totals.weak_winner_gross_profit + totals.strong_winner_gross_profit;
//   const winnerHandsCount = totals.unknown_winner_hands + totals.weak_winner_hands + totals.middle_winner_hands + totals.strong_winner_hands;
//   const winnersCount = totals.unknown_winners_count + totals.weak_winners_count + totals.middle_winners_count + totals.strong_winner_hands;
//   const winnersCoinPrice = (totals.unknown_winner_avg_chip_price + totals.weak_winners_count + totals.middle_winners_count + totals.strong_winner_hands)/4;
//   const winnersBigBlind = (totals.unknown_winner_avg_big_blind + totals.weak_winner_avg_big_blind + totals.middle_winner_avg_big_blind + totals.strong_winner_avg_big_blind)/4;
//   const winnersRake = totals.unknown_winner_rake + totals.weak_winner_rake + totals.middle_winner_rake + totals.strong_winner_rake;
//   const loserRake = totals.unknown_loser_rake + totals.weak_loser_rake + totals.middle_loser_rake + totals.strong_loser_rake;
//   const heroNetProfit = totals.hero_gross_profit - totals.hero_rake
//
//   return {
//     winnerProfi,
//     winnerHandsCount,
//     winnersCount,
//     winnersCoinPrice,
//     winnersBigBlind,
//     winnersRake,
//     loserRake,
//     heroNetProfit
//   }
// }
/*export const calculateDataForPieChart = (data: PeriodStatisticsDto[]) => {



  // Reduce (sum) all "number" fields (despite of other fields)
  const totals = data?.reduce((acc, item) => {

    for (const key in item) {
      // @ts-ignore
      if (typeof item[key] === "number") {
        // @ts-ignore
        acc[key] = (acc[key] || 0) + item[key];
      }
    }
    return acc;
  }, {} as PeriodStatisticsDto);

  if (totals === undefined) return {};

  const allWinnersGrossProfitTotal = totals.middle_winner_gross_profit + totals.weak_winner_gross_profit + totals.strong_winner_gross_profit;
  const allWinnersHandsByPeriod = totals.unknown_winner_hands + totals.weak_winner_hands + totals.middle_winner_hands + totals.strong_winner_hands;
  const allWinnersCountByPeriod = totals.unknown_winners_count + totals.weak_winners_count + totals.middle_winners_count + totals.strong_winner_hands;
  const allWinnersAvgCoinPriceByPeriod = (totals.unknown_winner_avg_chip_price + totals.weak_winners_count + totals.middle_winners_count + totals.strong_winner_hands)/4;
  const allWinnersAvgBigBlindByPeriod = (totals.unknown_winner_avg_big_blind + totals.weak_winner_avg_big_blind + totals.middle_winner_avg_big_blind + totals.strong_winner_avg_big_blind)/4;
  const allWinnersRakeByPeriod = totals.unknown_winner_rake + totals.weak_winner_rake + totals.middle_winner_rake + totals.strong_winner_rake;
  const allLosersRakeByPeriod = totals.unknown_loser_rake + totals.weak_loser_rake + totals.middle_loser_rake + totals.strong_loser_rake;
  const heroNetProfitTotal = totals.hero_gross_profit - totals.hero_rake

  return {
    allWinnersGrossProfitTotal,
    allWinnersHandsByPeriod,
    allWinnersCountByPeriod,
    allWinnersAvgCoinPriceByPeriod,
    allWinnersAvgBigBlindByPeriod,
    allWinnersRakeByPeriod,
    allLosersRakeByPeriod,
    heroNetProfitTotal
  }
}*/

// export const calculateForBarChart = (data: PeriodStatisticsDto[]) => {
//   return data?.map((it) => {
//     const winnerProfit =
//       it.unknown_winner_gross_profit +
//       it.weak_winner_gross_profit +
//       it.middle_winner_gross_profit +
//       it.strong_winner_gross_profit;
//     const winnerHandsCount =
//       it.unknown_winner_hands +
//       it.weak_winner_hands +
//       it.middle_winner_hands +
//       it.strong_winner_hands;
//     const winnersCount =
//       it.unknown_winners_count +
//       it.weak_winners_count +
//       it.middle_winners_count +
//       it.strong_winner_hands;
//     const winnersCoinPrice =
//       it.unknown_winner_avg_chip_price +
//       it.weak_winners_count +
//       it.middle_winners_count +
//       it.strong_winner_hands;
//     const winnersBigBlind =
//       it.unknown_winner_avg_big_blind +
//       it.weak_winner_avg_big_blind +
//       it.middle_winner_avg_big_blind +
//       it.strong_winner_avg_big_blind;
//     const winnersRake =
//       it.unknown_winner_rake +
//       it.weak_winner_rake +
//       it.middle_winner_rake +
//       it.strong_winner_rake;
//
//     const loserProfit = it.unknown_loser_gross_profit + it.weak_loser_gross_profit + it.middle_loser_gross_profit + it.strong_loser_gross_profit
//     const loserHandsCount = it.unknown_loser_hands + it.weak_loser_hands + it.middle_loser_hands + it.strong_loser_hands
//     const loserRake = it.unknown_loser_rake + it.weak_loser_rake + it.middle_loser_rake + it.strong_loser_rake
//
//     const rakedProfit = winnerProfit - winnersRake; //net profit
//     const rakedProfitUsd = rakedProfit * winnersCoinPrice;
//     /*val winnerProfit = it.unknownWinnerGrossProfit + it.weakWinnerGrossProfit + it.middleWinnerGrossProfit + it.strongWinnerGrossProfit
//       val winnerHandsCount = it.unknownWinnerHands + it.weakWinnerHands + it.middleWinnerHands + it.strongWinnerHands
//       val winnersRake = it.unknownWinnerRake + it.weakWinnerRake + it.middleWinnerRake + it.strongWinnerRake
//       val winnersCount = it.unknownWinnersCount + it.weakWinnersCount + it.middleWinnersCount + it.strongWinnersCount
//       val winnersCoinPrice = (it.unknownWinnerAvgChipPrice + it.weakWinnerAvgChipPrice + it.middleWinnerAvgChipPrice + it.strongWinnerAvgChipPrice) / 4
//       val winnersBigBlind = (it.unknownWinnerAvgBigBlind + it.weakWinnerAvgBigBlind + it.middleWinnerAvgBigBlind + it.strongWinnerAvgBigBlind) / 4
//
//       val rakedProfit = winnerProfit - winnersRake
//       val rakedProfitUsd = rakedProfit * winnersCoinPrice
//       val rakedProfitBb = rakedProfit / winnersBigBlind*/
//     return {period: it.period, rakedProfit, rakedProfitUsd, winnersRake, winnersCount, winnerHandsCount, winnersCoinPrice, winnersBigBlind,
//       loserHandsCount, loserRake, loserProfit}
//   });
//
// }
/*export const calculateForBarChart = (data: PeriodStatisticsDto[]) => {
  return data?.map((it) => {
    const allWinnersGrossProfitByPeriod =
      it.unknown_winner_gross_profit +
      it.weak_winner_gross_profit +
      it.middle_winner_gross_profit +
      it.strong_winner_gross_profit;
    const allWinnersHandsByPeriod =
      it.unknown_winner_hands +
      it.weak_winner_hands +
      it.middle_winner_hands +
      it.strong_winner_hands;
    const allWinnersCountByPeriod =
      it.unknown_winners_count +
      it.weak_winners_count +
      it.middle_winners_count +
      it.strong_winner_hands;
    const allWinnersAvgCoinPriceByPeriod =
      it.unknown_winner_avg_chip_price +
      it.weak_winners_count +
      it.middle_winners_count +
      it.strong_winner_hands;
    const allWinnersAvgBigBlindByPeriod =
      it.unknown_winner_avg_big_blind +
      it.weak_winner_avg_big_blind +
      it.middle_winner_avg_big_blind +
      it.strong_winner_avg_big_blind;
    const allWinnersRakeByPeriod =
      it.unknown_winner_rake +
      it.weak_winner_rake +
      it.middle_winner_rake +
      it.strong_winner_rake;*/

// export const calculateForBarAUChart = (data: PeriodStatisticsDto[]) => {
//   return calculateForBarChart(data).reduce(
//       (acc, item) => {
//         acc.period.push(item.period);
//         acc.winnerHandsCount.push(item.winnerHandsCount);
//         acc.loserHandsCount.push(item.loserHandsCount);
//
//         //acc.winnersRake.push(item.winnersRake);
//         //acc.loserRake.push(item.loserRake);
//
//         //acc.winnersCount.push(item.winnersCount);
//
//         //acc.loserCount(item.loserCount)
//         //acc.loserProfit.push(item.loserProfit);
//         return acc;
//       },
//       {
//         period: [] as string[],
//         winnerHandsCount: [] as number[],
//         loserHandsCount: [] as number[],
//         winnersRake: [] as number[],
//         loserRake: [] as number[],
//         winnersCount: [] as number[],
//         loserCount: [] as number[],
//         //loserProfit: [] as number[],
//       }
//     )
//     ?? {}
// }
/*    const allLoserProfitByPeriod = it.unknown_loser_gross_profit + it.weak_loser_gross_profit + it.middle_loser_gross_profit + it.strong_loser_gross_profit
    const allLosersHandsByPeriod = it.unknown_loser_hands + it.weak_loser_hands + it.middle_loser_hands + it.strong_loser_hands
    const allLosersRakeByPeriod = it.unknown_loser_rake + it.weak_loser_rake + it.middle_loser_rake + it.strong_loser_rake

    const allWinnersNetProfitByPeriod = allWinnersGrossProfitByPeriod - allWinnersRakeByPeriod; //net profit
    const allWinnersNetProfitByPeriodUsd = allWinnersNetProfitByPeriod * allWinnersAvgCoinPriceByPeriod;
    const allLosersNetProfitByPeriod = allLoserProfitByPeriod - allLosersRakeByPeriod; //net profit
    const heroNetProfitByPeriod = it.hero_gross_profit - it.hero_rake; //net profit
    /!*val allWinnersGrossProfitByPeriod = it.unknownWinnerGrossProfit + it.weakWinnerGrossProfit + it.middleWinnerGrossProfit + it.strongWinnerGrossProfit
      val allWinnersHandsByPeriod = it.unknownWinnerHands + it.weakWinnerHands + it.middleWinnerHands + it.strongWinnerHands
      val allWinnersRakeByPeriod = it.unknownWinnerRake + it.weakWinnerRake + it.middleWinnerRake + it.strongWinnerRake
      val allWinnersCountByPeriod = it.unknownWinnersCount + it.weakWinnersCount + it.middleWinnersCount + it.strongWinnersCount
      val allWinnersAvgCoinPriceByPeriod = (it.unknownWinnerAvgChipPrice + it.weakWinnerAvgChipPrice + it.middleWinnerAvgChipPrice + it.strongWinnerAvgChipPrice) / 4
      val allWinnersAvgBigBlindByPeriod = (it.unknownWinnerAvgBigBlind + it.weakWinnerAvgBigBlind + it.middleWinnerAvgBigBlind + it.strongWinnerAvgBigBlind) / 4

      val rakedProfit = allWinnersGrossProfitByPeriod - allWinnersRakeByPeriod
      val rakedProfitUsd = rakedProfit * allWinnersAvgCoinPriceByPeriod
      val rakedProfitBb = rakedProfit / allWinnersAvgBigBlindByPeriod*!/
    return {period: it.period, allWinnersNetProfitByPeriod, allWinnersNetProfitByPeriodUsd, allWinnersRakeByPeriod, allWinnersCountByPeriod, allWinnersHandsByPeriod, allWinnersAvgCoinPriceByPeriod, allWinnersAvgBigBlindByPeriod,
      allLosersHandsByPeriod, allLosersRakeByPeriod, allLoserProfitByPeriod, allLosersNetProfitByPeriod, heroGrossProfitByPeriod: it.hero_gross_profit, heroNetProfitByPeriod}
  });

}

export const calculateForBarAUChart = (data: PeriodStatisticsDto[]) => {
  return calculateForBarChart(data).reduce(
      (acc, item) => {
        acc.period.push(item.period);
        acc.allWinnersHandsByPeriod.push(item.allWinnersHandsByPeriod);
        acc.allLosersHandsByPeriod.push(item.allLosersHandsByPeriod);

        //acc.allWinnersRakeByPeriod.push(item.allWinnersRakeByPeriod);
        //acc.allLosersRakeByPeriod.push(item.allLosersRakeByPeriod);

        //acc.allWinnersCountByPeriod.push(item.allWinnersCountByPeriod);

        //acc.loserCount(item.loserCount)
        //acc.allLoserProfitByPeriod.push(item.allLoserProfitByPeriod);
        return acc;
      },
      {
        period: [] as string[],
        allWinnersHandsByPeriod: [] as number[],
        allLosersHandsByPeriod: [] as number[],
        allWinnersRakeByPeriod: [] as number[],
        allLosersRakeByPeriod: [] as number[],
        allWinnersCountByPeriod: [] as number[],
        loserCount: [] as number[],
        //allLoserProfitByPeriod: [] as number[],
      }
    )
    ?? {}
}*/
